<div class="popup-dark-view" (click)="dismiss()">
  <div class="popup-holder" id="child">
    <div class="popup-top-div">{{ inputs.description }}</div>
    <div class="popup-bot-div">
      <div
        class="popup-button"
        style="border-left: 1px solid #eeeeee"
        (click)="confirm()"
      >
        {{ inputs.rightButton }}
      </div>
      <div class="popup-button" (click)="dismiss()">
        {{ inputs.leftButton }}
      </div>
    </div>
  </div>
</div>
